import React, { useContext, useEffect, Fragment } from 'react';
import AuthContext from '../../Context/autenticacion/authContext';
import AddAdmin from './AddAdmin';
import AddSeller from './AddSeller';
import AlertNotAuthorized from '../../Complements/AlertNotAuthorized';
import SchoolContext from '../../Reducers/Schools/SchoolContext';

export default function ClassroomIndex(props) {
   //Extraer la informacion de autenticación
   const authContext = useContext(AuthContext);
   const { usuario, usuarioAutenticado } = authContext;

   useEffect(() => {
    usuarioAutenticado();
  }, []);

  let component;
  if(usuario){
    switch (usuario.type) {
		case '1':
			component = <AddAdmin {...props} />
			break;
		case '2':
			component = <AddSeller {...props} />
			break;
		case '3':
			component = <AddSeller {...props} />
			break;
		  default:
			component = <AlertNotAuthorized mensaje={"No tienes los suficientes permisos para ver esta página"}/>
			break;
    }
  }
  return (
    <Fragment>
      {component}
    </Fragment>
  )
}
